export const TOKEN_NAME = 'nebula_token';
export const USER_ITEM_NAME = 'nebula_user';
export const LANG_NAME = 'nebula_lang';
export const CART_DATA = 'nebula_cart';
export const TOKEN_PREFIX = 'Bearer ';
export const MAX_UPLOAD_SIZE = 307200; // 300KB
export const LANGUAGES = ['pl', 'en']; // must be exactly two lowercase letters

export const GOOGLE_MAPS_API_KEY = "AIzaSyC3U3geO4uRnaiSNgvFZvlIstURkm8Myew";
export const GOOGLE_MAPS_STATIC_KEY = "AIzaSyC3U3geO4uRnaiSNgvFZvlIstURkm8Myew";
export const GOOGLE_GEOCODE_API_KEY = "AIzaSyC3U3geO4uRnaiSNgvFZvlIstURkm8Myew";

/*eslint-disable*/
export const FORM_TEXTS = {
  required: 'To pole jest wymagane',
  confirm_password: 'Hasła nie są identyczne',
  password_min: 'Hasło powinno mieć co najmniej ${min} znaków',
  min: 'To pole powinno mieć co najmniej ${min} znaków',
  max: 'To pole nie może mieć więcej niż ${max} znaków',
  email: 'Adres email nie jest poprawny',
  exact(number) {
    return `To pole musie mieć dokładnie ${number} znaków`;
  },
  invalid_format: 'To pole ma nieprawidłowy format',
};
/*eslint-enable*/



// WEBPACK FOOTER //
// ./src/CONSTANTS.js